import { Component, Input } from '@angular/core';
import { FicheConseil } from '@lib/models/generated/graphql';
import { Subject, takeUntil } from 'rxjs';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';

@Component({
  template: '',
})
export abstract class AbstractStepComponent {
  @Input()
  title: string = '';

  protected currentFicheConseil: FicheConseil | null = null;
  protected ngUnsubscribe = new Subject<void>();

  constructor(protected ficheConseilService: FicheConseilService) {}

  ngOnInit(): void {
    this.ficheConseilService.currentFicheConseilSubject
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(newFicheConseil => {
        this.beforeFicheConseilUpdate(newFicheConseil, this.currentFicheConseil);
        this.currentFicheConseil = newFicheConseil;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  public abstract beforeFicheConseilUpdate(
    newFicheConseil: FicheConseil | null,
    previousFicheConseil: FicheConseil | null
  ): void;

  public abstract isStepValid(): boolean;

  public abstract markAsTouched(): void;
}
